import { render, staticRenderFns } from "./BaseFileDropArea.vue?vue&type=template&id=70eec518&scoped=true&lang=pug"
import script from "./BaseFileDropArea.vue?vue&type=script&lang=ts"
export * from "./BaseFileDropArea.vue?vue&type=script&lang=ts"
import style0 from "./BaseFileDropArea.vue?vue&type=style&index=0&id=70eec518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eec518",
  null
  
)

export default component.exports